const wowApp = require('angular').module('wowApp');

wowApp.config(['RestangularProvider', require('./restangular')]);
wowApp.config(['$urlMatcherFactoryProvider', require('./urlmatcher').urlMatcherConfig]);
wowApp.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', require('./routes')]);
wowApp.config(['$httpProvider', '$provide', require('./http')]);
wowApp.config(['$provide', require('./state')]);
wowApp.config(['$provide', require('./location')]);
wowApp.config(['$compileProvider', require('./compile')]);
wowApp.config(['$ocLazyLoadProvider', require('./modules')]);

wowApp.run(['$rootScope', '$state', 'ShopperService', 'LoginService', 'PageMetadataService', 'MemoScrollService', 'MoveFocus', 'AnalyticsService', 'Settings', require('./startup')]);

// Setup Page Analytics.
wowApp.service('PageAnalytics', ['AnalyticsService', '$rootScope', '$location', '$window', '$document', 'BreakpointsService', 'ShopperService', 'ShopperAnalyticsService', require('./analytics/page-analytics')]);

// Run Initial Page Load Analytics.
wowApp.run(['PageAnalytics', 'Settings', require('./analytics/page-analytics-setup')]);




// WEBPACK FOOTER //
// ./src/configuration/index.js